import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { AiAnalystPage } from '@/components/AiAnalyst/AiAnalystPage'
import {
  aiAnalystConversationSearchSchema,
  withoutAiAnalystSearchDefaults,
  type AiAnalystSearch,
} from '@/components/AiAnalyst/aiAnalystSearch'
import { inPageSearch, type SearchChangeOptions } from '@/lib/searchNavigation'

/** Wiring only. The schema lives beside the page in `aiAnalystSearch.ts`. */
export const Route = createFileRoute('/_app/ai-analyst/c/$conversationId')({
  validateSearch: aiAnalystConversationSearchSchema,
  component: ConversationIdRoute,
})

function ConversationIdRoute() {
  const { conversationId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  const onSearchChange = useCallback(
    (next: Partial<AiAnalystSearch>, options?: SearchChangeOptions) =>
      void navigate(inPageSearch(withoutAiAnalystSearchDefaults, next, options)),
    [navigate],
  )

  return (
    <AiAnalystPage
      conversationId={conversationId}
      search={search}
      onSearchChange={onSearchChange}
      onOpenConversation={(id) =>
        void navigate({
          to: '/ai-analyst/c/$conversationId',
          params: { conversationId: id },
          search: (current) => current,
        })
      }
      onNewChat={() => void navigate({ to: '/ai-analyst', search: (current) => current })}
    />
  )
}
